import React, { useState, useEffect } from 'react';
import FormPurchase from './FormPurchase';
import Select from 'react-select'

import { isEmpty } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';

import CurrencyFormat from 'react-currency-format';
import { TableRow, TableCell, Button, TableBody, IconButton } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import { CloseRounded } from '@material-ui/icons';
import { Fragment } from 'react';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import { generateUniqueId, regexFLOAT, regexINT } from '../../../../commonModules/utils/statsFunctions';

const Form = (props) => {

    const [state, setState] = useState({ 
        // New purchase
        purchase: {
            shop: "",
            shopDisplay: {label: "", value:""},
            nature: "achat",
            total:0,
            totalHT:0,
            transport:"",
            fact_id_5000: "",
            taxes:"",
            comments:"",
            received: false,
            transfer_files_req: null,
            is_imported: false,
            products:[
                {
                    display:{},
                    product_id:"",
                    quantity:"",
                    price:"",
                }
            ],
        },
        // errors?
        errors: {
            shop: "",
            nature:"",
            transport:"",
            taxes:"",
            products: [
                {
                    product_id:"",
                    quantity:"",
                    price:"",
                }
            ],
        },
        numberProd: 1,
        view: "form",
        uniqueID: generateUniqueId(),
        sending: false,
        form:<div></div>
    })
    const [form,setForm] = useState(<div></div>)
    const [fieldList, setFieldList] = useState([]);

    useEffect(() => {
        const { arrivage, PRODUCTS, SHOPS, oldPurchase, update } = props;

        if (!isEmpty(arrivage)) {

            let numberProd = arrivage.products.length
            let arrPurchase = Object.assign({},arrivage)
            let errors = Object.assign({}, state.errors)
            errors.products = props.errors // from Arrivage.jsx

            if( PRODUCTS ){
                Object.values(arrPurchase.products).forEach( (product, i) => {   
                    let prodInfo = PRODUCTS[product.product_id]                    
                    arrPurchase.products[i].display = {
                        value:prodInfo.id, 
                        label:`${prodInfo.marque} - ${prodInfo.name}`, 
                        disabled:true
                    } 
                    arrPurchase.products[i].installQty = product.quantity
                })
            }

            setState(prevState => ({
                ...prevState,
                numberProd,
                purchase: arrPurchase,
                errors
            })) 
        } else if (!isEmpty(oldPurchase)) {

            let numberProd = oldPurchase.products.length
            let newPurchase = {
                shop: oldPurchase.shop_id,
                shopDisplay: {
                    label: SHOPS[oldPurchase.shop_id].name, 
                    value: oldPurchase.shop_id,
                    // disabled: true,
                },
                nature: "achat",
                total: oldPurchase.prix_revient,
                totalHT: oldPurchase.prix_ht,
                transport: oldPurchase.transport,
                fact_id_5000: oldPurchase.fact_id_5000,
                taxes: oldPurchase.taxes,
                comments: oldPurchase.comments,
                received: false,
                // received: oldPurchase.received,
                transfer_files: oldPurchase.transfer_files,
                transfer_files_req: [],
                is_imported: oldPurchase.is_imported,
                products: [],
            }
            let errors = Object.assign({}, state.errors)

            if( PRODUCTS ){
                Object.values(oldPurchase.products).forEach( (product, i) => {   
                    let prodInfo = PRODUCTS[product.product_id]                    
                    newPurchase.products.push(
                        {
                            display: {
                                value: prodInfo.id, 
                                label:`${prodInfo.marque} - ${prodInfo.name}`, 
                                // disabled: false
                            } ,
                            product_id: prodInfo.id,
                            quantity: product.quantity,
                            price: product.total_ht,
                        }
                    )
                    
                    errors.products[i] = {
                        product_id: "",
                        quantity: "",
                        price: "",
                    }
                })
            }

            setState(prevState => ({
                ...prevState,
                numberProd,
                purchase: newPurchase,
                errors
            })) 
        } 
    }, []);

    useEffect(() => {
        createAddForm();
      }, [state.purchase]);

    const createProductList = () => {// select product options in Form
        const list = []
        const { PRODUCTS } = props
        if( PRODUCTS ){
            Object.values(PRODUCTS).map( product => {   
                let selected = false
                if (!product.is_disabled){
                    state.purchase.products.forEach( prod  => {   
                        if(prod.product_id  === product.id) {  // already selected   
                            selected = true 
                        } 
                    })
                    list.push (       
                        {value:product.id, label:`${product.marque} - ${product.name}`, disabled:selected} 
                    )
                }
            })
            return list
        } else {
            return false
        }
    }
    const handleSelect = (option, name) => {
        console.log("SELECT HANDLE",{option, name});

        let value = option.value
        let displayName = name +'Display'
        
        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                [name]:value,
                [displayName]:option
            }
        }))
    }
    const handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE",{option, index});

        let value = option.value

        let cpProducts = state.purchase.products
        cpProducts[index].product_id = value            
        cpProducts[index].display = option

        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                products:cpProducts,
            }
        }))
    }
    const createAddForm = () => {// form for new product in purchase form
        const tab = []
        const { purchase, errors } = state;
        if (purchase.shop === ""){
            return
        }
        const products = createProductList()

         console.log("[INFO] CREATE ADD FORM INDEX ");

        for (let i = 0; i < state.numberProd;i++) {
            const PU = (
                ( purchase.products[i].quantity 
                    && (purchase.products[i].quantity > 0)
                ) && purchase.products[i].price
            ) ? Math.round((purchase.products[i].price / purchase.products[i].quantity) * 100 ) / 100 
            : 0;

            console.log({product_i: purchase.products[i]});
            tab.push(
                <TableRow key={i}>
                    {/* <TableCell>
                        {state.numberProd > 1 &&
                        <IconButton 
                            className="delete-line" 
                            onClick={() => handleDeleteProd(i) }
                        >
                            <CloseRounded color="error" />
                        </IconButton>
                        }
                   
                        <InputSelectMagasin
                            helperText={ (state.purchase.products[i] && state.purchase.products[i].installQty) && 
                                `Quantité prévue : ${purchase.products[i].installQty}`
                            }
                            options={products}
                            value={purchase.products[i].display || {value:"", label: ""}}
                            onChange={option => handleSelectProducts(option,i)}
                            error={state.errors.products[i].product_id}
                            label="Produit"
                            placeholder="Selectionner un Produit"
                            /> 
                        </TableCell>                                 */}
                    <ProductLineCell
                        numberProd={state.numberProd}
                        handleDeleteProd={() => handleDeleteProd(i)}
                        options={products}
                        value={purchase.products[i].display || {value:"", label: ""}}
                        onChange={option => handleSelectProducts(option,i)}
                        error={state.errors.products[i].product_id}
                        helperText={ (state.purchase.products[i] && state.purchase.products[i].installQty) && 
                            `Quantité prévue : ${purchase.products[i].installQty}`
                        }
                        PRODUCTS={props.PRODUCTS}
                    />
                    
                    <TableCell>
                        <InputText 
                            type="number" 
                            min={1} 
                            step={10} 
                            onChange={handleChange} 
                            value={purchase.products[i].quantity} 
                            name={"prod_-quantity-"+i} 
                            placeholder="Quantité"
                            label="Quantité"
                            error={errors.products[i].quantity}
                        />
                    </TableCell>                            
                    <TableCell>
                        <InputText 
                            disabled
                            value={PU} 
                            label="Prix Unitaire"
                        />
                    </TableCell>
                        
                    <TableCell>
                        <InputText 
                            type="number" min={1} step={100} 
                            onChange={handleChange} 
                            onBlur={total} 
                            value={purchase.products[i].price} 
                            name={"prod_-price-"+i} 
                            title="Prix HT Total"
                            error={errors.products[i].price}
                        />
                    </TableCell>
                </TableRow>
            )
        }

        setForm(tab);
        return tab;
    }
    const handleAddProd = () => {// add new line in the form to add a product to the purchase
        const { purchase } = state;
        if (purchase.shop === ""){
            toast.error("Shop must be selected")
            return
        }
        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                products:[
                    ...state.purchase.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    price:"",
                }]
            },
            errors:{
                ...state.errors,
                products:[
                    ...state.errors.products,{
                    product_id:"",
                    quantity:"",
                    price:"",
                    
                }]
            },
            numberProd:state.numberProd + 1,
        }))   
    }
    const handleAddProdByCSV = (productList) =>{
        console.log("Form Purchase ,handleAddProdByCSV,",productList)
        if (state.purchase.shop === ""){
            toast.error("Shop must be selected")
            return
        }
        const productListLocal = new Array();
        const productListLocalErr = new Array();

        var total = 0 
        let nbOfProduct = 0;

        productList.forEach((value, key)=>{
            console.log("Form Sales ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            nbOfProduct++

            const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2],
                price: value[3],
              };
            const productEntryErr = {                      
                product_id:"",
                quantity:"",
                price:""
            };

            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);
            total += parseFloat(value[3])
         
        })
        console.log("Form Purchase ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form Purchase ,handleAddProdByCSV,Add product",productListLocal.length)
            setState(prevState => ({
                ...prevState,
                purchase:{
                    ...state.purchase,
                    products:[...productListLocal]

                },
                totalHT:total,
                total:total+parseFloat(state.transport)+parseFloat(state.taxes),
                errors:{
                    ...state.errors,
                    products:[...productListLocalErr]
                },
                numberProd:nbOfProduct,
            })) 
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }
    const handleDeleteProd = (index) => {// delete line in the form to add a product to the purchase
        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                products:[
                    ...state.purchase.products.slice(0,index),
                    ...state.purchase.products.slice(index +1),
                ]
            },
            errors:{
                ...state.errors,
                products:[
                    ...state.errors.products.slice(0,index),
                    ...state.errors.products.slice(index +1),   
                ]
            },
            numberProd:state.numberProd-1,
        }))  
    }

    const handleChange = async  (e) => {  
        const field = e.target.name
        const value = e.target.value
        const floatFields = [
            "transport",
            "taxes",
            "price",
            "douane",
            "other_taxes",
            "transit",
            "TVA",
        ]
        // const regex = /^[0-9\b]+$/ // int only
        // const regexFloat = /^[+]?([0-9]*(\.[0-9]*)?)$/ // numbers (int & float) only
        console.log({field, value})
        let purchaseUpdate = Object.assign({}, state.purchase)
        
        if(floatFields.includes(field)){
            if(value === "" || regexFLOAT.test(value)){ // update value only if its a int || float
                purchaseUpdate[field] = value
                let totals = calcTotal(purchaseUpdate)
                purchaseUpdate.total = totals[0]
                purchaseUpdate.totalHT = totals[1]
            }

        } else if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            if(name === "quantity") {
                if(value ==="" || regexINT.test(value)){ // update value only if its a int
                    purchaseUpdate.products[index][name] = value
                }
            } else if(floatFields.includes(name)){
                if(value ==="" || regexFLOAT.test(value)){ // update value only if its float
                    purchaseUpdate.products[index][name] = value
                    let totals = calcTotal(purchaseUpdate)
                    purchaseUpdate.total = totals[0]
                    purchaseUpdate.totalHT = totals[1]
                }
            } else {
                purchaseUpdate.products[index][name] = value
            }
        } else if( field === "fact_id_5000"){
            purchaseUpdate.fact_id_5000 = value.trim()
        } else {
            purchaseUpdate[field] = value
        }
        setState(prevState => ({
            ...prevState,
            purchase: purchaseUpdate
        })) 
    }
    const setFiles = (list) => {
        console.log("[INFO] SETFILES", list);
        
        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                transfer_files_req:list
            }
        }))
    }
    const calcTotal = (purchase = state.purchase) => {// calc total cost of purchase
        let total = 0
        let totalHT = 0
        if(purchase.products.length > 0){
            purchase.products.map((prod, i) => {
                if(prod.price !== ""){
                    totalHT += parseFloat(prod.price)
                    total += parseFloat(prod.price)
                    console.log("cProd loop",prod.price , i)
                }
            })
        }
        if(purchase.transport !== ""){
            total += parseFloat(purchase.transport)
        }
        if(purchase.taxes !== ""){
            total += parseFloat(purchase.taxes)
        }

        return [total, totalHT]
    }
    const total = () => {// calc total cost of purchase
        const res = calcTotal()
        let total = res[0]
        let totalHT = res[1]

        console.log("CPRODUIT", total );
        setState(prevState => ({
            ...prevState,
            purchase:{
                ...state.purchase,
                total,
                totalHT,
            }
        })) 
        return total
    }
    
    const validate = () => {// checks if no error in form before sending it to Back
        let noErrors = true
        let errors = Object.assign({}, state.errors)
        total()
        let data = Object.assign({}, state.purchase)
    
        Object.keys(data).map( field => {
            if (field === "fact_id_5000") {
                errors[field] = ""
                
            } else if (data[field] === "" || data[field] === [] ){// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if(field === "products") {
                data.products.forEach((item, j) => {
                    Object.keys(item).map( field2 => { // field2 product_id || quantity
                        console.log('====================================');
                        console.log({item, field2, value: item[field2]});
                        console.log('====================================');
                        if( 
                            (isEmpty(item[field2]) && !item[field2]) || 
                            item[field2] === 0 || 
                            item[field2] === "0"
                        ){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })
            } else { // not empty
                errors[field] = ""   
            }
        })
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        setState(prevState => ({
            ...prevState,
            errors
        }))
        if (noErrors) {
            
            setState(prevState => ({
                ...prevState,
                view: "confirm" }))
        } else {
            toast.error( "Le formulaire contient des erreurs")
        }
    }
    const handleSubmit = async () => {
        setState(prevState => ({
            ...prevState, sending: true }))

                let purchase = Object.assign({}, state.purchase)
                purchase.id = ""
                purchase.prix_revient = total()
                purchase.prix_ht = parseFloat(purchase.totalHT)
                purchase.transport = parseFloat(purchase.transport)
                purchase.taxes = parseFloat(purchase.taxes)
                purchase.shop_id = purchase.shop
                purchase.creation_date = new Date()
                purchase.unique_id = state.uniqueID
                
                if (!isEmpty(props.arrivage)) {
                    purchase.arrivage_id = props.arrivage.id
                }
                
                let totalProd = 0;
                for (let i = 0; i < purchase.products.length; i++){

                    purchase.products[i].quantity = parseInt(purchase.products[i].quantity)
                    purchase.products[i].price = parseFloat(purchase.products[i].price)
                    purchase.products[i].priceU = parseFloat(purchase.products[i].price) / purchase.products[i].quantity
                    totalProd += parseFloat(purchase.products[i].price)

                    console.log("TOTAL", totalProd);
                }

                purchase.surcout = ((parseFloat(purchase.taxes) + parseFloat(purchase.transport) )/ totalProd) + 1
                console.log("surcout, TOTALPROD TAXES ", purchase.surcout, totalProd, purchase.taxes, props.arrivage);

                try{
                    if( props.update) {
                        purchase.id = props.oldPurchase.id
                        const resp = await props.updatePurchase(purchase)
                        toast.info("L'achat a été modifié avec succès")
                    } else {
                        const resp = await props.createPurchase(purchase)
                        toast.info("L'achat a été enregistré avec succès")
                    }
                    console.log("fetched");
                    handleClose()
                }catch(err){
                    console.log("ERROR", props.STATE.purchases.error);
                        
                    toast.error( props.STATE.purchases.error)
                    setState(prevState => ({
                        ...prevState, sending: false }))
                }
                
    }

    const handleClose = () => {
        console.log('====================================');
        console.log("HANDLE CLOSE");
        console.log('====================================');
        clearForms() // /!\ to clear products form
        props.handleClose()
    }
    const clearForms = () => {// clear form after submit or cancel
        console.log("clearForms");
        console.log('====================================');
        
        setState({
            // New purchase
            purchase: {
                shop: "",
                shopDisplay: {label: "", value:""},
                nature:"achat",
                total:0,
                totalHT:0,
                transport:"",
                fact_id_5000:"",
                taxes:"",
                comments:"",
                received: false,
                transfer_files_req: null,
                products:[
                    {
                        display:{},
                        product_id:"",
                        quantity:"",
                        price:"",
                    }
                ],
            },
            // errors?
            errors: {
                shop: "",
                nature:"",
                transport:"",
                taxes:"",
                products:[
                    {
                        product_id:"",
                        quantity:"",
                        price:"",
                    }
                ],
            },
            numberProd: 1,
            sending: false,
        })
    }
        
    useEffect(() => {
        const purchase = state.purchase
        let displayFiles = []
        if (state.view === "confirm" && !isEmpty(purchase.transfer_files_req) ) {
            displayFiles = purchase.transfer_files_req.map(file => (file.filename))
        }
        const newFieldList = [
            {name: "nature", label:"Nature", display: purchase.nature },
            {name: "shop", label:"Magasin", display: purchase.shopDisplay.label },
            // {name: "fact_id_5000", label:"N° Facture", display: purchase.fact_id_5000 },
            // {name: "received", label:"Commande reçue", display: (purchase.received ? "Oui" : "Non") },
            {name: "is_imported", label:"Importé", display: (purchase.is_imported ? "Oui" : "Non") },
            {name: "transfer_files_req", label:"Documents", display: displayFiles.join(" | ") },
            {name: "space"},
            {name: "products"},  
            {name: "space"},
            {name: "totalHT", label:"Total HT", display:<CurrencyFormat value={purchase.totalHT} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>},
            {name: "transport", label:"Transport", display: <CurrencyFormat value={purchase.transport} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>},
            {name: "taxes", label:"Autres Taxes", display: <CurrencyFormat value={purchase.taxes} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>},
            {name: "total", label:"Total", display: <b>{<CurrencyFormat value={purchase.total} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/>}</b>},
            {name: "comments", label:"Remarques", display: purchase.comments },
        ]     
        setFieldList(newFieldList);
        }, [state.purchase]);  

        return (
            <div>
                {state.view === "form" &&
                    <FormPurchase 
                        {...state} 
                        {...props}
                        total={total}
                        createAddForm={form}
                        handleAddProdByCSV={handleAddProdByCSV}
                        handleAddProd={handleAddProd}
                        handleSelect={handleSelect}
                        handleChange={handleChange}
                        setFiles={setFiles}
                        handleCheck={(value, name) => setState(prevState => ({
                            ...prevState, 
                            purchase: {
                                ...state.purchase, 
                                [name]: value
                            } 
                        }))}
                        validate={validate}
                        handleSubmit={validate}
                        handleClose={handleClose}
                    />
                }
                {state.view === "confirm" &&
                    <PopUp 
                        title="Confirmation Vente" 
                        close={() => setState(prevState => ({
                            ...prevState,view: "form"}))}
                        submitAction={ handleSubmit }
                        disabledSubmit={state.sending}
                    >
                        <TableLayout>
                            <TableBody>
                            
                            {fieldList.map( field => {
                                if (field.name === "products"){
                                    return (
                                        <React.Fragment>
                                            <TableRow>
                                                <TableCell rowSpan={ state.purchase.products.length + 1 }>Produits</TableCell>
                                                <TableCell>Nom</TableCell>
                                                <TableCell>Quantité</TableCell>
                                                <TableCell>Total</TableCell>
                                            </TableRow>
                                            {state.purchase.products.map( prod => (
                                                <TableRow style={{backgroundColor:"lightyellow"}}>
                                                    <TableCell style={{width:"400px"}}>{prod.display.label}</TableCell>
                                                    <TableCell><b>{prod.quantity}</b> x <CurrencyFormat value={(Math.round((prod.price / prod.quantity) * 100 ) / 100) || 0
                                                    } displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/></TableCell>
                                                    
                                                    <TableCell><b><CurrencyFormat value={prod.price} displayType={'text'} thousandSeparator={" "} suffix={" FCFA"}/></b></TableCell>
                                                </TableRow>
                                                )
                                            )}
                                        </React.Fragment>
                                    )
                                } else if (field.name === "space"){
                                    return <TableRow><TableCell colSpan={4}></TableCell></TableRow>
                                } else {
                                    return (
                                        <TableRow>
                                            <TableCell>{field.label}</TableCell>
                                            <TableCell >{field.display}</TableCell>
                                            <TableCell colSpan={2}></TableCell>
                                        </TableRow>
                                    )
                                }
                            })

                            }                            
                            </TableBody>
                        </TableLayout>
                    </PopUp>
                }
            </div>
                
        );
}

export default Form;